<template>
  <div class="results-list">
    <div
      v-if="!allowPlayerResults"
      class="d-flex align-items-center justify-content-center h-100 mb-5"
    >
      <div class="tournament-operator">
        <Icon name="Attention-battle" width="40" />
        <span>{{
          $t(
            'web_match_results_operator',
            'Match results will be provided by tournament operator'
          )
        }}</span>
      </div>
    </div>

    <BattleStatusPanel
      v-if="!isBattleRoyale"
      hide-room
      hide-actions
      :hide-countdown="resultsProvided"
    />
    <!-- <div v-if="isBattleRoyale" class="countdown-battle-royale">
      <TextBlock
        :text="
          $t(
            '_web_battle_royale_countdown_results',
            'The game lobby administrator will provide results in the next'
          )
        "
        size="1.2"
        :variant="'bold'"
        tag="p"
        class="mb-0 secondary-font"
      />
      <Countdown
        :date="countdownOptions.date"
        :separator="' : '"
        :variant="'muted'"
        class="mb-0"
      />
    </div> -->
    <div class="d-flex content justify-content-around start-battle-sm">
      <div
        class="d-flex flex-column  align-items-center justify-content-center results-col"
      >
        <HeraDummyList
          v-if="!isLoading && isEmptyList"
          icon-name="dummy/matches"
          position="center"
          :header-text="$$t('Your match list is empty.', 'empty-list')"
          :text="
            $$t(
              'There are so many competitions await for you',
              'empty-list_subheader'
            )
          "
        />
        <HeraDummyList
          v-if="isLoading"
          class="position-relative pre-loader"
          position="center"
        />
        <template v-else-if="!canStartBattle">
          <template v-if="isDuelMatch && !isBeforeStart">
            <div
              v-for="(round, index) in rounds"
              :key="index"
              class="mb-3 w-100"
            >
              <div
                v-if="roundToEdit === index"
                class="col-12 results-editor mt-5"
              >
                <ProvideBattleResults
                  :round-number="index"
                  :my-account-number="battle.myIndex"
                  inline
                  disable-autofocus
                  @change="setBattleResults"
                />
              </div>
              <div v-else class="col-12 mt-5 p-4 results-view">
                <div
                  class="col-12 d-flex flex-column justify-content-center align-items-center"
                >
                  <Subheader
                    :text="
                      $$t('Game {number} of {total}', 'round-game-label', {
                        number: index + 1,
                        total: rounds.length,
                      })
                    "
                    :size="1"
                    class="secondary-font"
                  />
                  <TextBlock
                    v-if="resultsNotMatched(index)"
                    :text="$$t('Not matched')"
                    variant="error"
                    :size="0.75"
                  />
                </div>
                <div
                  class="d-flex justify-content-center custom-scrollbar mb-2"
                >
                  <div
                    v-if="!battle.myIndex || battle.myIndex === 0"
                    class="results-item w-100"
                  >
                    <BattleCard
                      v-if="results"
                      class="h-100 "
                      :battle="battle"
                      :player="
                        battle && battle.players[0] && battle.players[0].profile
                      "
                      :second-player="
                        battle && battle.players[1] && battle.players[1].profile
                      "
                      :results="results.player_1_match_results[index]"
                      :my-account-number="battle.myIndex"
                    />
                  </div>
                  <div v-else class="results-item w-100">
                    <BattleCard
                      v-if="results"
                      class="h-100"
                      :battle="battle"
                      :player="
                        battle && battle.players[0] && battle.players[1].profile
                      "
                      :second-player="
                        battle && battle.players[1] && battle.players[0].profile
                      "
                      :results="results.player_2_match_results[index]"
                      :my-account-number="battle.myIndex"
                    />
                  </div>
                </div>
                <!-- <div
              class="d-flex flex-column justify-content-center align-items-center col-12 mt-5"
            >
              <SecondaryText
                class="mx-2"
                :text="
                  $$t(
                    'The administrator will determine the winner using the attached media if you not update result',
                    'update-results-text'
                  )
                "
              /> -->
                <!-- link always to current account player number -->
                <!-- <div class="text-center mt-3">
                <Btn
                  :label="
                    didIFillResults(index)
                      ? $$t('Update results')
                      : $$t('Provide results')
                  "
                  class="btn-primary btn-sm flex-shrink-0"
                  :disabled="!canEdit"
                  @click="editResults(index)"
                />
              </div>
            </div> -->
              </div>
            </div>
          </template>
          <template v-else-if="isBattleRoyale && !isBeforeStart">
            <template v-if="battle.myIndex !== null">
              <ProvideBattleRoyaleResults
                v-if="!battleRoyaleResultsProvided && allowPlayerResults"
                :login="account.login"
                disable-autofocus
                class="w-100 mt-5"
                @change="setBattleRoyaleResults"
              />
              <div v-else class="results-view w-100 mt-5">
                <BattleCard
                  class="h-100"
                  :battle="battle"
                  :player="battle.players[battle.myIndex].profile"
                  :results="battleRoyaleResults"
                  :my-account-number="battle.myIndex"
                  royale
                />
              </div>
            </template>
            <BattleRoyaleResults
              v-else
              :results="results.match_results.players_results"
              :players="battle.players"
              class="royale-results-table"
            />
          </template>
        </template>
      </div>
      <div v-if="battle.isParticipant" class="notes-col p-5">
        <div class="note-title secondary-font my-4">
          <span>{{ $$t('How to start the battle?') }}</span>
        </div>
        <div class="row note-item px-3">
          <Icon class="icon" name="chat-plus-color" :width="24" />
          <span>
            {{ $$t('Contact your opponent via chat') }}
          </span>
        </div>
        <div class="row note-item px-3">
          <Icon class="icon" name="target" :width="24" />
          <span>
            {{ $$t('Find each other in a game') }}
          </span>
        </div>
        <div class="row note-item px-3">
          <Icon class="icon" name="hex-check" :width="24" />
          <span>
            {{ $$t('Play and have fun') }}
          </span>
        </div>
        <div class="note-title secondary-font my-4">
          <span>{{ $$t('How to provide results?') }}</span>
        </div>
        <div class="row note-item px-3">
          <Icon class="icon" name="scores" :width="24" />
          <span>
            {{ $$t('For each game provide a score') }}
          </span>
        </div>
        <div class="row note-item px-3">
          <Icon class="icon" name="camera-color" :width="24" />
          <span>
            {{ $$t('Attach photo with prove') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

// import SecondaryText from '@/components/atoms/SecondaryText';
import Subheader from '@/components/atoms/Subheader';
// import Btn from '@/components/atoms/HeraFormBtn';
import BattleCard from './BattleCard';
import HeraDummyList from '@/components/common/HeraDummyList';
import TextBlock from '@/components/atoms/TextBlock';
import { BATTLE_STATUSES } from '@/constants/battles';
import { BLOCK_TYPES } from '@/constants/tournaments';
import { translate } from '@/mixins/translate';
import BattleStatusPanel from './BattleStatusPanel.vue';
import ProvideBattleResults from './ProvideBattleResults.vue';
import ProvideBattleRoyaleResults from './ProvideBattleRoyaleResults.vue';
import Icon from '@/components/atoms/Icon';
import BattleRoyaleResults from './BattleRoyaleResults.vue';
// import Countdown from '@/components/common/Countdown.vue';

export default {
  name: 'BattleResults',
  components: {
    TextBlock,
    // SecondaryText,
    Subheader,
    // Btn,
    BattleCard,
    HeraDummyList,
    BattleStatusPanel,
    ProvideBattleResults,
    ProvideBattleRoyaleResults,
    Icon,
    BattleRoyaleResults,
    // Countdown,
  },
  mixins: [translate('_web_battle-results-tab')],
  data() {
    return {
      isLoading: true,
      currentDate: Date.now() / 1e3,
    };
  },
  computed: {
    ...mapState('current', { battleId: 'accountId' }),
    ...mapState('my', ['account']),
    ...mapGetters({
      resultsByMatchId: 'resultsByMatchId',
      battle: 'dynamicBattleModel',
    }),
    rounds() {
      return Array(this.battle.numberOfMatches || 1);
    },
    countdownOptions() {
      let date;

      date = this.battle.endDate;
      date = date && this.currentDate < date ? date : null;
      return { date };
    },
    isEmptyList() {
      return (
        this.results &&
        !this.results.player_1_match_results.length &&
        !this.results.player_2_match_results.length
      );
    },
    canStartBattle() {
      return (
        this.battle &&
        this.battle.status === BATTLE_STATUSES.pending &&
        this.battle.canManageBattle
      );
    },
    roundToEdit() {
      var round = -1;
      if (
        !this.isBattleCompleted &&
        !this.$lodash.isEmpty(this.results) &&
        this.results[`player_${1 + this.battle.myIndex}_match_results`]
      ) {
        this.results[`player_${1 + this.battle.myIndex}_match_results`].forEach(
          (element, index) => {
            if (
              round == -1 &&
              element.player_1_scored == null &&
              element.player_2_scored == null
            ) {
              round = index;
            }
          }
        );
      }
      return round;
    },
    canEdit() {
      return (
        [BATTLE_STATUSES.started].includes(this.battle.status) &&
        this.battle.canManageBattle
      );
    },
    results() {
      return this.resultsByMatchId(this.battle.id || this.battle._id) || null;
    },
    isDuelMatch() {
      return this.$lodash.get(this.results, 'type', '') !== 'battle_royale';
    },
    isBattleCompleted() {
      return this.battle.status === BATTLE_STATUSES.completed;
    },
    isBeforeStart() {
      return [BATTLE_STATUSES.pending, BATTLE_STATUSES.scheduled].includes(
        this.battle.status
      );
    },
    isBattleRoyale() {
      return this.battle.type === BLOCK_TYPES.BATTLE_ROYALE;
    },
    allowPlayerResults() {
      return this.battle.allowPlayerResults;
    },
    battleRoyaleResults() {
      return this.isBattleRoyale && this.results
        ? this.battle.myIndex != null
          ? this.results.match_results.players_results[this.battle.myIndex]
          : null
        : null;
    },
    battleRoyaleResultsProvided() {
      return this.battleRoyaleResults && this.battleRoyaleResults.rank;
    },
    resultsProvided() {
      return !!(this.battleRoyaleResultsProvided || this.roundToEdit == -1);
    },
  },
  created() {
    this.addSystemSubscriber(this.setBattleMatchResult);
  },
  mounted() {
    this.getBattleResults({
      battleID: this.battle ? this.battle.id : this.battleId,
      rounds: this.rounds.length,
    });
    this.isLoading = false;
  },
  destroyed() {
    this.removeSystemSubscriber(this.setBattleMatchResult);
  },
  methods: {
    ...mapActions([
      'getBattleResults',
      'setBattleResults',
      'addSystemSubscriber',
      'removeSystemSubscriber',
    ]),
    ...mapMutations(['updateMatchResults']),
    editResults(round) {
      this.$router.push({
        name: 'results-edit',
        params: {
          round,
        },
      });
    },
    setBattleRoyaleResults(data) {
      this.setBattleResults(data).then(() => {
        this.getBattleResults({
          battleID: this.battle ? this.battle.id : this.battleId,
          rounds: this.rounds.length,
        });
      });
    },
    setBattleMatchResult(data) {
      if (
        data.type === 'battle_match_result_updated' &&
        data.extended.battleId === this.battle.id
      ) {
        let results = this.$lodash.cloneDeep(this.results);
        results[`${data.extended.providedBy}_match_results`][
          data.extended.round
        ] = {
          player_1_scored: data.extended.player1Scored,
          player_2_scored: data.extended.player2Scored,
          attachments: data.extended.attachments,
          uri: data.extended.uri,
          text: data.extended.text,
          round: data.extended.round,
        };

        this.updateMatchResults({
          battleID: this.battle.id,
          results,
        });
      }
    },
    didIFillResults(roundIndex) {
      if (!this.results) {
        return;
      }
      const myResults = this.results[
        `player_${this.battle.myIndex + 1}_match_results`
      ][roundIndex];
      return (
        Number.isSafeInteger(myResults.player_1_scored) &&
        Number.isSafeInteger(myResults.player_2_scored)
      );
    },
    isResultsFilled(roundIndex) {
      const firstPlayerScores = this.results.player_1_match_results[roundIndex];
      const secondPlayerScores = this.results.player_2_match_results[
        roundIndex
      ];
      return (
        Number.isSafeInteger(firstPlayerScores.player_1_scored) &&
        Number.isSafeInteger(firstPlayerScores.player_2_scored) &&
        Number.isSafeInteger(secondPlayerScores.player_1_scored) &&
        Number.isSafeInteger(secondPlayerScores.player_2_scored)
      );
    },
    isResultEqual(roundIndex, playerIndex) {
      return (
        this.results.player_1_match_results[roundIndex][
          `player_${playerIndex}_scored`
        ] ===
        this.results.player_2_match_results[roundIndex][
          `player_${playerIndex}_scored`
        ]
      );
    },
    resultsNotMatched(index) {
      return (
        this.results &&
        this.canEdit &&
        this.isResultsFilled(index) &&
        (!this.isResultEqual(index, 1) || !this.isResultEqual(index, 2))
      );
    },
  },
};
</script>

<style lang="scss">
.results-list {
  margin-top: 24px;

  .results-col {
    width: 832px;
    height: fit-content;

    .results-view {
      border: solid 1px var(--ph-input-borders);
      border-radius: 20px;
    }
  }

  .notes-col {
    min-width: 255px;

    .note-title {
      font-size: 1rem;
      font-weight: 600;
    }

    .note-item {
      font-size: 0.75rem;
      align-items: center;

      .icon {
        margin: 0.5rem;
      }
    }
  }
}

.tournament-operator {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 30px;
  align-items: center;
  animation: fadeIn 3s ease-in-out forwards infinite;

  span {
    font-size: x-large;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

.countdown-battle-royale {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

@media (max-width: 767px) {
  .start-battle-sm {
    flex-direction: column;
  }

  .results-list {
    margin-bottom: 24px;

    .results-col {
      width: unset;
    }
  }
}
</style>
